// src/components/settings/SettingsTable.js
import React from 'react';
import styled from 'styled-components';
import { FaEdit, FaTrash } from 'react-icons/fa';

const Table = styled.table`
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;

  th, td {
    padding: 12px;
    border-bottom: 1px solid ${(props) => props.theme.colors.inputBorder};
    text-align: left;
  }

  th {
    background-color: ${(props) => props.theme.colors.primary};
    color: white;
  }

  td.actions {
    display: flex;
    justify-content: space-around;
  }

  svg {
    cursor: pointer;
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

const SettingsTable = ({ settings, handleEdit, handleDelete }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {settings.map((setting) => (
          <tr key={setting.id}>
            <td>{setting.key}</td>
            <td>{JSON.stringify(setting.value)}</td>
            <td className="actions">
              <FaEdit onClick={() => handleEdit(setting.id)} />
              <FaTrash onClick={() => handleDelete(setting.id)} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SettingsTable;
